import type { FaireProductEntity } from "../../entity_types/product";

export const p_378256aeq7: FaireProductEntity = {
  token: "p_378256aeq7",
  type: "product",
  name: "Feelings Stress Toy x Adam JK",
  brandToken: "b_3fio9sxbn1",
  brandName: "Third Drawer Down USA",
  imageUrl:
    "https://cdn.faire.com/fastly/e01341784412bacd51943a626c5bcc3f908bba5717a8b66e4ed52f76402cf1ff.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/238cfd0733c12a31b51e773d53c1f866e87cfdb0bc5c3191d23473dab18776b0.jpeg",
    "https://cdn.faire.com/fastly/8fde062452ffb5399265819554b2c62b3e3cd88ca653b7c051c14e55a0d0e215.jpeg",
    "https://cdn.faire.com/fastly/adb626639877588dc75501a0bc3bd08b11ed0c75bdd91dda66f4ccce744bf9ac.jpeg",
  ],
  priceDollars: 6.75,
  description:
    "Feelings Stress Toy x Adam JK\n\nAn obvious reminder that while there's so much power in being soft and in touch with your feelings, you can't actually bottle them up forever. Let it go.\n\nPractice unclenching your fists with this super-squishy version of Adam JK's instantly-relatable Feelings jar.\n\n𝐀𝐛𝐨𝐮𝐭 𝐭𝐡𝐞 𝐚𝐫𝐭𝐢𝐬𝐭\n\nAdam J. Kurtz (aka Adam JK) is a designer, artist, author and speaker whose illustrative work is rooted in honesty, humor and a little darkness. His books have been translated into over a dozen languages. Kurtz speaks frankly about channeling human emotion into our art, and generally just trying to be more okay with whatever we’ve got.\n\n\n𝐒𝐩𝐞𝐜𝐢𝐟𝐢𝐜𝐚𝐭𝐢𝐨𝐧𝐬\n\n• PU Foam\n• 8 x 10 cm - 3 x 4”",
  tags: [],
  msrpDollars: 13.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:40.340Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
